import { PathProperty as PathProp } from '../../peregrineFlowInterfaces';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { NodePropertyProp } from '../NodePropertyPane';
import { useCallback, useEffect, useState } from 'react';
import FileManager, { FileEntry } from '../../FileBrowser/FileManager';
import { SharedFile } from '../../FileBrowser/SharedFileBrowser';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import VariableAutocompleteTextField from './VariableAutocompleteTextField';


function PathProperty({ property, onChange }: NodePropertyProp) {
    const p = property as unknown as PathProp;
    const [path, setPath] = useState<string>(p.value);
    const [changed, setChanged] = useState<boolean>(false);
    const [showFileManager, setShowFileManager] = useState<boolean>(false);

    useEffect(() => {
        if (!changed) {
            return
        }

        p.value = path;
        onChange?.(p)
        setChanged(false);
    }, [path, changed, p, onChange])


    const onFileManagerClose = useCallback(() => {
        setShowFileManager(false);
    }, []);

    const onSelectFile = useCallback((entry: FileEntry | SharedFile) => {
        setChanged(true);
        setPath(entry.path);
        setShowFileManager(false);
    }, []);

    return (
        <Box sx={{ width: '100%' }}>
            <Box display="flex" alignItems="center">
                <Typography variant="caption">{p.label}</Typography>
                {p.description && (
                    <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{p.description}</div>} componentsProps={{ tooltip: { sx: { maxWidth: 'none' } } }}>
                        <HelpOutline fontSize="small" sx={{ ml: 1, color: 'text.secondary', cursor: 'help', width: 16, height: 16 }} />
                    </Tooltip>
                )}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', width: '100%' }}>
                <VariableAutocompleteTextField
                    fullWidth
                    variant="outlined"
                    value={path}
                    description={p.description}
                    onValueChange={(v) => setPath(v)}
                    onBlur={() => setChanged(true)}
                    sx={{ textOverflow: 'ellipsis' }}
                    onKeyDownCapture={(e) => {
                        if (e.key !== "Enter")
                            return

                        setChanged(true);
                    }}
                />

                <Tooltip title="Browse Files">
                    <IconButton type="button" sx={{ ml: 1, mb: 1 }} aria-label="search" onClick={() => setShowFileManager(true)}>
                        <OpenInBrowserIcon />
                    </IconButton>
                </Tooltip>

                <FileManager
                    open={showFileManager}
                    onClose={onFileManagerClose}
                    mode="select"
                    onSelectFile={onSelectFile}
                    title="Select File"
                />
            </Box>
        </Box>
    )
}

export default PathProperty;
